var styles = {"root":"Slider_root__1XNXm","slide":"Slider_slide__1eUuz","wrapper":"Slider_wrapper__2xX-0","arrow":"Slider_arrow__2KEmO","arrowRight":"Slider_arrowRight__2tj72","arrowLeft":"Slider_arrowLeft__1-_OC"};

export default styles;
